module.exports = __webpack_public_path__ + "static/media/flushed.1a506f81.svg";